import { defineMessages } from "react-intl";

const baseId = "t.components.modals.contactsModal.";

export default defineMessages({
  usernameLabel: {
    id: baseId + "usernameLabel",
    defaultMessage: "Username",
  },
  uigpContactMethod: {
    id: baseId + "uigpContactMethod",
    defaultMessage: "OTP UIGP",
  },
});
